import React from 'react'
import { useTranslation } from 'react-i18next'
import { Link as RouterLink } from 'react-router-dom'
import { styled, useTheme } from '@mui/material/styles'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

import RegisterForm from './components/RegisterForm'
import { en, pl, de } from './locales'

const RootStyle = styled('div')(({ theme }: { theme: any }) => ({
   display: 'flex',
   height: 'auto',
   marginTop: 'auto',
   marginBottom: 'auto',
   paddingLeft: '30px',
   alignItems: 'center',
   paddingRight: '30px',
   margin: '0 auto',
   ...(theme.breakpoints.down('lg') && {
      paddingLeft: 0,
      ml: 0,
      paddingRight: 0,
      // overflow: 'hidden',
   }),
   justifyContent: 'space-between',
}))

export default function Register() {
   const theme = useTheme()
   const { t, i18n } = useTranslation('REGISTER')
   i18n.addResourceBundle('pl-PL', 'REGISTER', pl)
   i18n.addResourceBundle('en-EN', 'REGISTER', en)
   i18n.addResourceBundle('de-DE', 'REGISTER', de)

   return (
      <Box sx={{ flex: 1, display: 'flex', alignItems: 'center' }}>
         <RootStyle>
            {/* <Hidden width="lgDown">
               <SectionStyle>
                  <img
                     style={{ margin: 'auto 0' }}
                     alt="register"
                     src="https://files.motorro.eu/img/slider/rejestracja baner 2.png"
                  />
               </SectionStyle>
            </Hidden> */}
            <Box
               sx={{
                  mx: 'auto',
                  maxWidth: { lg: 'max-content', md: 'max-content', xs: 'auto' },

                  p: { lg: '16px', md: '16px', xs: '0px' },
               }}
            >
               <Box>
                  <Box sx={{ mb: 1, ml: 1, display: 'flex', alignItems: 'center' }}>
                     <Box sx={{ flexGrow: 1 }}>
                        <Typography variant="h4" color="primary" gutterBottom>
                           {t('mainSite.registerTitle')}
                        </Typography>
                     </Box>
                  </Box>
                  <Box>
                     <RegisterForm />
                  </Box>
                  <Box sx={{ mt: 0 }}>
                     <Typography variant="body2" align="center" sx={{ color: 'text.secondary' }}>
                        {t('mainSite.byRegisteringTitle')}
                        <RouterLink
                           style={{
                              textDecoration: 'none',
                              color: theme.palette.primary.main,
                           }}
                           to="https://motorro.pl/regulamin/"
                           target="_blank"
                        >
                           {` ${t('mainSite.termsOfService')}`}
                        </RouterLink>
                        <span> {t('mainSite.and')} </span>
                        <RouterLink
                           style={{
                              textDecoration: 'none',
                              color: theme.palette.primary.main,
                           }}
                           to="https://motorro.pl/polityka-prywatnosci/"
                           target="_blank"
                        >
                           {t('mainSite.privacyPolicy')}
                        </RouterLink>
                        .
                     </Typography>
                     <Typography variant="subtitle2" sx={{ textAlign: 'center' }}>
                        <span>{t('mainSite.backToLoginTitle')} </span>
                        <RouterLink
                           style={{
                              textDecoration: 'none',
                              color: theme.palette.primary.main,
                           }}
                           to="/"
                        >
                           {t('mainSite.loginButton')}
                        </RouterLink>
                     </Typography>
                  </Box>
               </Box>
            </Box>
         </RootStyle>
      </Box>
   )
}
